import { render, staticRenderFns } from "./getSalesInfoManage.vue?vue&type=template&id=05375613&scoped=true"
import script from "./getSalesInfoManage.vue?vue&type=script&lang=js"
export * from "./getSalesInfoManage.vue?vue&type=script&lang=js"
import style0 from "./getSalesInfoManage.vue?vue&type=style&index=0&id=05375613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05375613",
  null
  
)

export default component.exports